import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AcondicionamientoEnvaseControllerService } from './api/acondicionamientoEnvaseController.service';
import { AcondicionamientoTipoControllerService } from './api/acondicionamientoTipoController.service';
import { AportacionDIEstadoControllerService } from './api/aportacionDIEstadoController.service';
import { AportacionDIPoseedorControllerService } from './api/aportacionDIPoseedorController.service';
import { CampanaGestoresResiduosControllerService } from './api/campanaGestoresResiduosController.service';
import { CampanaPoseedoresControllerService } from './api/campanaPoseedoresController.service';
import { CodigoOperacionControllerService } from './api/codigoOperacionController.service';
import { CodigosLerMaterialControllerService } from './api/codigosLerMaterialController.service';
import { CvfCodLerOperacionControllerService } from './api/cvfCodLerOperacionController.service';
import { CvfControllerService } from './api/cvfController.service';
import { CvfEstadosControllerService } from './api/cvfEstadosController.service';
import { CvfMaterialesCodLerControllerService } from './api/cvfMaterialesCodLerController.service';
import { CvfMermasControllerService } from './api/cvfMermasController.service';
import { CvfOperacionDestinoFinalControllerService } from './api/cvfOperacionDestinoFinalController.service';
import { FacturaPoseedorControllerService } from './api/facturaPoseedorController.service';
import { FacturaPoseedorEstadosControllerService } from './api/facturaPoseedorEstadosController.service';
import { GestoresResiduosControllerService } from './api/gestoresResiduosController.service';
import { GestoresResiduosEstadosControllerService } from './api/gestoresResiduosEstadosController.service';
import { MotivosBajaControllerService } from './api/motivosBajaController.service';
import { MotivosBajaGestoresControllerService } from './api/motivosBajaGestoresController.service';
import { OperacionGestionControllerService } from './api/operacionGestionController.service';
import { ParametrosControllerService } from './api/parametrosController.service';
import { PeriodoFacturacionControllerService } from './api/periodoFacturacionController.service';
import { PoseedorAdheridoControllerService } from './api/poseedorAdheridoController.service';
import { PoseedorControllerService } from './api/poseedorController.service';
import { PoseedorEstadoControllerService } from './api/poseedorEstadoController.service';
import { ResiduoEnvaseControllerService } from './api/residuoEnvaseController.service';
import { ResiduosGestionadosControllerService } from './api/residuosGestionadosController.service';
import { TarifaPoseedoresControllerService } from './api/tarifaPoseedoresController.service';
import { PlataformaOrigenControllerService } from './api/plataformaOrigenController.service';
import { FacturaCvfControllerService } from './api/facturaCvfController.service';

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [
        AcondicionamientoEnvaseControllerService,
        AcondicionamientoTipoControllerService,
        AportacionDIEstadoControllerService,
        AportacionDIPoseedorControllerService,
        CampanaGestoresResiduosControllerService,
        CampanaPoseedoresControllerService,
        CodigoOperacionControllerService,
        CodigosLerMaterialControllerService,
        CvfCodLerOperacionControllerService,
        CvfControllerService,
        CvfEstadosControllerService,
        CvfMaterialesCodLerControllerService,
        CvfMermasControllerService,
        FacturaPoseedorControllerService,
        FacturaPoseedorEstadosControllerService,
        GestoresResiduosControllerService,
        GestoresResiduosEstadosControllerService,
        OperacionGestionControllerService,
        ParametrosControllerService,
        PlataformaOrigenControllerService,
        PoseedorAdheridoControllerService,
        PoseedorControllerService,
        PoseedorEstadoControllerService,
        ResiduoEnvaseControllerService,
        ResiduosGestionadosControllerService,
        TarifaPoseedoresControllerService,
        PlataformaOrigenControllerService,
        CampanaGestoresResiduosControllerService,
        FacturaCvfControllerService,
        CvfOperacionDestinoFinalControllerService,
        MotivosBajaControllerService,
        MotivosBajaGestoresControllerService,
        PeriodoFacturacionControllerService,
        MotivosBajaControllerService,
    ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: ApiModule,
        @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
                'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
